import { useState, memo } from 'react'

import { ListItemText, makeStyles, Box } from '@material-ui/core'
import { DataGrid } from '@material-ui/data-grid'

import { ConfirmationDialog } from 'UI/Components'

import { EditDictionaryWordDialog } from './EditDictionaryWordDialog'

const useStyles = makeStyles(() => ({
    grid: {
        '& .MuiDataGrid-cell': {
            outline: 'none!important',
            cursor: 'pointer'
        }
    },
    title: {
        fontSize: '24px',
        fontWeight: 400
    },
    subTitle: {
        fontSize: '11px'
    },
    description: {
        '& span:first-letter': {
            textTransform: 'capitalize'
        }
    }
}))

export const DictionaryList = memo(({ dictionary, deletePhrase }) => {
    const classes = useStyles()

    const [deleteId, setDeleteId] = useState(null)
    const [editId, setEditId] = useState(null)

    const handleRemove = () => {
        deletePhrase(deleteId).then(() => {
            setDeleteId(null)
            setEditId(null)
        })
    }

    if (!dictionary) return null

    return (
        <Box mt={3} width="100%">
            <DataGrid
                autoHeight
                pageSize={25}
                className={classes.grid}
                rowsPerPageOptions={[25]}
                onRowClick={({ id }) => setEditId(id)}
                columns={[
                    {
                        field: 'phrase',
                        minWidth: 400,
                        flex: 1,
                        headerName: 'Phrase',
                        renderCell: ({ row }) => <ListItemText>{row.phrase}</ListItemText>
                    },
                    {
                        field: 'description',
                        headerName: 'Description',
                        minWidth: 400,
                        flex: 1,
                        renderCell: ({ row }) => (
                            <ListItemText className={classes.description}>
                                {row.description}
                            </ListItemText>
                        )
                    }
                ]}
                disableColumnMenu
                sortModel={[{ field: 'phrase', sort: 'asc' }]}
                rows={Object.values(dictionary)?.filter(Boolean)}
            />
            <ConfirmationDialog
                isOpen={Boolean(deleteId)}
                onClose={() => setDeleteId(null)}
                onConfirm={handleRemove}
                title="Are you sure?"
                text={
                    <>
                        Remove dictionary phrase <b>{dictionary[deleteId]?.phrase}</b> ?
                    </>
                }
            />
            {dictionary[editId] && !deleteId && (
                <EditDictionaryWordDialog
                    editData={dictionary[editId]}
                    onClose={() => setEditId(null)}
                    setDeleteId={setDeleteId}
                />
            )}
        </Box>
    )
})
